import React, { Component } from 'react';
import { translate } from 'react-i18next';
import Octicon, {Clock} from '@githubprimer/octicons-react';
import PropTypes from 'prop-types';
import moment from 'moment/src/moment';

class Timestamp extends Component {
  render() {
    const { t, i18n, value } = this.props;
    return (
      <span className="ml-1 mr-1">
        <Octicon icon={Clock}/> { moment(value).format('DD.MM.YYYY HH:mm') }
      </span>
    );
  }
}

Timestamp.propTypes = {
  value: PropTypes.object
};

export default translate('translations')(Timestamp);



// WEBPACK FOOTER //
// ./components/Timestamp.js